<template>
  <div :class="{ 'd-flex justify-center full-width scroll-container': true, 'mx-auto': xl }" style="max-width: 1880px">
    <v-dialog fullscreen v-model="largeImg">
      <v-card v-if="zoomImage" @click="largeImg = false">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="largeImg = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div :class="{ 'pr-3 pb-3 pl-3': !xs }">
          <img
            style="width: 100%; background-size: contain; box-shadow: 0px 6px 12px -6px rgba(0, 0, 0, 0.6) !important; border: 1px solid rgba(0, 0, 0, 0.3)"
            :src="imageUrl(zoomImage)"
            :alt="zoomImage.filename"
          />
        </div>
        <v-card-text :class="{ 'text-h6': true, 'pa-3': xs, 'pr-3 pb-3 pl-3': !xs }" v-if="zoomImage.description">{{ zoomImage.description }}</v-card-text>
      </v-card>
    </v-dialog>

    <div style="max-width: 1880px">
      <masonry class="masonry mt-3" :cols="{ default: 3, 1024: 2, 500: 1 }" :gutter="{ default: '12px' }">
        <div v-for="(image, i) in images" :key="i" class="item pb-3">
          <v-img
            :src="imageUrl(image)"
            @click="
              largeImg = true;
              zoomImage = image;
            "
            class="shadow"
          >
          </v-img>
          <div v-if="image.description" class="imageOverlay pb-3">
            {{ image.description }}
          </div>
        </div>
      </masonry>
    </div>
  </div>
</template>

<script>
import config from '@/common/config';
import { mapState } from 'vuex';
import commonMixin from '@/mixins/common';
import index from './index';

export default {
  name: 'GalleryMasonry',
  components: {},
  mixins: [commonMixin],
  mounted() {
    this.$store.dispatch('gallery/markAsRead', this.gallery);
  },
  data() {
    return {
      zoomImage: null,
      largeImg: false,
    };
  },
  computed: {
    ...mapState('gallery', ['galleriesById']),

    gallery() {
      let gallery = this.galleriesById[this.$route.params.galleryId];
      if (!gallery) {
        console.debug('No gallery with id=this.$route.params.galleryId', this.$route.params.galleryId);
        return {};
      }
      return gallery;
    },
    images() {
      return this.gallery._images ? this.gallery._images.slice().sort((a, b) => a.sort - b.sort) : [];
    },
  },
  methods: {
    imageUrl(image) {
      return `${config.apiUrl}/medias/${index.api}/${image.filename}/${image.checksum}`;
    },
  },
};
</script>

<style scoped>
.masonry {
  max-width: calc(100vw - 12px);
}
.masonry .item {
  position: relative;
}
.masonry .v-image {
  cursor: pointer;
  box-shadow: 0px 6px 12px -6px rgba(0, 0, 0, 0.6) !important;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
.masonry .item .imageOverlay {
  position: absolute;
  width: 100%;
  bottom: 12px;
  height: 40px;
  background: black;
  color: white;
  opacity: 0.6;
  padding-left: 12px;
  line-height: 40px;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-dialog__content {
  line-height: 0;
}
</style>
